import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const userState = useSelector((state) => state.userState);
  const { userInfo } = userState;

  return userInfo && userInfo?.role == "ROLE_MERCHANT" ? (
    <Outlet />
  ) : userInfo && (userInfo?.role == "ROLE_ADMIN" || "ROLE_SUPER_ADMIN") ? (
    <Navigate to={{ pathname: "/admin" }} />
  ) : (
    <Navigate to={{ pathname: "/login" }} />
  );
};

export default PrivateRoute;
